import axios from "axios";
import React, { createContext, useEffect, useState } from "react";

export const ConfigContext = createContext();

export const ConfigProvider = ({ children }) => {
const [permissions,setPermissions]=useState([]);
  // const [apiURL, setAPIURL] = useState("http://143.110.190.50:3188/");
  // const [apiURL, setAPIURL] = useState("http://143.110.190.50:4000/"); 
  const [apiURL, setAPIURL] = useState("https://uaterpapi.abstarthr.in/"); 
  //  const [apiURL, setAPIURL] = useState("http://localhost:4000/");
  const [companyName, setCompanyName] = useState("");
  const [token, setToken] = useState(localStorage.getItem("token_erp"));
  const [companyId, setCompanyId] = useState(localStorage.getItem("company_id_erp"));
  const [userId, setUserId] = useState(localStorage.getItem("user_id_erp"));
  const [apiHeaderJSON, setHeaderJSON] = useState({ 
    token: `${token}`, 
    "Content-Type": "application/json", 
    "x-company-id": companyId, 
    "x-user-id": userId, });
  const [apiHeaderFile, setHeaderFile] = useState({ 
    token: `${token}`, 
    "Content-Type": "multipart/form-data", 
    "x-company-id": companyId, 
    "x-user-id": userId, });

  useEffect(() => {
    const storedToken = localStorage.getItem("token_erp");
    if (storedToken) { setToken(storedToken); }
  }, []);

  const handleUpdateLogin = (data) => {
    setToken(data.token); //// Update context with new token
    localStorage.setItem("token_erp", data.token); // Store token in local storage
    localStorage.setItem("company_id_erp", data.company_id); // Store token in local storage
    localStorage.setItem("user_id_erp", data.company_user_id); // Store token in local storage
  };
  const getPermissions = () => {
    const headers = apiHeaderJSON;
    axios
      .get(`${apiURL}Employees/GetHeaderPermissionList`, {
        params: {},
        headers,
      })
      .then((response) => {
        let data = response.data;
        // console.log(data);
        if (response.data.success === true) {
          setPermissions(data?.result);
        } else {
          console.error("Error fetching list");
        }
      })
      .catch(function (error) {
        console.log("error", error);
      });
  };
  const placeHolderImageURL ="http://142.93.209.237:3188/public/placeholder_category.jpeg";

  var vals = {
    // payrollOtherHeadsRows,
    // setPayrollOtherHeadsRows,
    apiURL,
    setAPIURL,
    token,
    setToken,
    handleUpdateLogin,
    placeHolderImageURL,
    apiHeaderJSON,
    apiHeaderFile,
    permissions,
    setPermissions,
    getPermissions,
    companyName, 
    setCompanyName
  };
  return (
    <ConfigContext.Provider value={vals}>{children}</ConfigContext.Provider>
  );
};
